module.exports = __webpack_public_path__ + "assets/img/ground.webp?5862bab10bf43859b62b940dbf45919b";